import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { statusStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderDetailsStatus";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

statusStyles.wrapper = mergeToNew(statusStyles.wrapper, {
    width: 12,
    css: css`
        display: flex;
        width: 100%;
        max-width: 100%;
        flex-direction: column;
        padding: 0px;
    `,
});

statusStyles.titleText = mergeToNew(statusStyles.titleText, {
    css: css`
    margin-bottom: 0px;
    background:${themeBackgrounds.lightGray};
    padding: 16px;
    width: 100%;
  `
});

statusStyles.status = mergeToNew(statusStyles.status, {
    css: css`
      padding: 4px;
  `
});
